import { render, staticRenderFns } from "./RouletteSpinner.vue?vue&type=template&id=256e0b4a&"
import script from "./RouletteSpinner.vue?vue&type=script&lang=js&"
export * from "./RouletteSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports